const GOOGLE_DOC_URL_PATTERN =
  /^https:\/\/docs\.google\.com\/(?:a\/[^/]+\/)?document\/d\/([a-zA-Z0-9_-]+)/i;

export const isGoogleDocUrl = (uri: string): boolean =>
  GOOGLE_DOC_URL_PATTERN.test(uri);

export const extractGoogleDocId = (uri: string): string | undefined =>
  uri.match(GOOGLE_DOC_URL_PATTERN)?.[1];
